import { css, Theme } from "@emotion/react";

export const contentTable = css({
    position: "relative",
    display: "flex",
    zIndex: 101,
});

export const bottomTable = (theme: Theme) =>
    css({
        borderBottom: `1px solid ${theme.candy.keyPalette.primaryBackgroundColor}`,
    });

export const scrolledTable = (theme: Theme) =>
    css({
        borderBottom: theme.candy.tables.border.solid,
    });

export const bottomSpace = css({
    height: 35,
});

export const footerStop = css({
    position: "relative",
    // чтобы футер не наезжал на самую верхнюю строку
    top: 60,
});
